import { AfterViewInit, Component, ElementRef, forwardRef, Input, OnInit, ViewChild, ViewEncapsulation } from '@angular/core';
import { ControlValueAccessor, FormControl, NG_VALUE_ACCESSOR } from '@angular/forms';
import moment from 'moment';

@Component({
  selector: 'app-form-input-file',
  standalone: false,
  templateUrl: './form-input-file.component.html',
  styleUrl: './form-input-file.component.scss',
  encapsulation: ViewEncapsulation.None,
  providers: [
    {
      provide: NG_VALUE_ACCESSOR,
      useExisting: forwardRef(() => FormInputFileComponent),
      multi: true
    }
  ]
})
export class FormInputFileComponent implements OnInit, AfterViewInit, ControlValueAccessor {
  @Input() ext: string = 'file';
  @Input() field: string;
  @Input() formControl: FormControl;
  @Input() label: string;

  @ViewChild('fileUpload', { read: ElementRef }) fileUploadEl: ElementRef;

  public id: string;
  
  public onChange = (_: any) => {
  };
  public onTouch = () => {
  };

  constructor() {
  }

  ngOnInit(): void {
    this.id = `${this.field}-${moment().unix()}`;
  }

  ngAfterViewInit() {
    // it is necessary to trigger onRemove with input "Cancel" button click
    setTimeout(() => {
      const cancelBtn: HTMLButtonElement | null =
        this.fileUploadEl?.nativeElement?.querySelector('.p-fileupload-cancel-button');

      if (cancelBtn) {
        cancelBtn.addEventListener('click', () => {
          this.onRemove();
        });
      }
    });
  }

  // value accessor functions
  writeValue(): void {
  }

  registerOnChange(fn: any): void {
    this.onChange = fn;
  }

  registerOnTouched(fn: any): void {
    this.onTouch = fn;
  }

  // function to catch input changes and update form in parent
  public onInput($event: any): void {
    const files = Array.from($event.files || []);
    this.onTouch();
    this.onChange(files);
    this.formControl?.setValue(files);
  }

  public onRemove(): void {
    this.onTouch();
    this.onChange(undefined);
    this.formControl?.setValue(undefined);
  }
}
